<template>
	<div class="latform-hypertalk-container">
		<div class="content-container">
			<div class="breadcrumb">
				<router-link to="/painter-super-talk" class="breadcrumb-item">超话社区</router-link>
				<span class="breadcrumb-separator">></span>
				<span class="breadcrumb-item current">详情</span>
			</div>
			<div class="rankItem">
				<div class="work">
					<img class="workImg" :src="community.img" />
					<div class="workInfo">
						<div class="workTitle ellipsis-1">
							{{community.title}}
						</div>
						<div class="workDesc ellipsis-2">
							{{community.content}}
						</div>
						<div class="peopleComment">
							<div class="people">
								<img class="peopleIcon" src="../../assets/Home/people.png" />
								{{community.user_num}}人
							</div>
							<div class="comment">
								<img class="commentIcon" src="../../assets/Home/comment.png" />
								{{community.dt_num}}个
							</div>
						</div>
						<div class="tips">
							<div class="tip" v-for="(row,rowIndex) in community.label" :key="rowIndex">
								#{{row}}
							</div>
						</div>
					</div>
				</div>
				<!-- <div class="menuBox">
					<div class="menuItem publish" @click="dialogSendViable = true">
						<img class="publishIcon" src="../../assets/Home/publish.png" alt="" />
						发布动态
					</div>
					<div class="menuItem follow" @click="communityDianzan">
						{{community.gz_status == 0 ? '关注超话' : '取消关注'}}
					</div>
				</div> -->
			</div>
			<div class="naviBox">
				<div class="naviItem" :class="curNaviIndex == index ? 'active' : 'normal'"
					v-for="(item,index) in naviData" :key="index" @click="changeFenQu(index)">
					{{item.title}}
				</div>
			</div>
			<div class="commentBoxList">
				<div class="comment" v-for="(item,index) in data" :key="index">
					<div class="userInfoBox">
						<div class="userInfo">
							<img class="avatar" :src="item.user.avatar" v-if="item.user && item.user.avatar" />
							<img class="avatar" src="../../assets/Personal/iconF.png" v-else />
							<div class="nameTimeIdentity">
								<div class="nameBox">
									{{item.user && item.user.user_nickname ? item.user.user_nickname : ''}}
									<div class="toTop" v-if="item.zd_status == 1">
										<img class="toTopIcon" src="../../assets/Home/toTop.png" />
										置顶
									</div>
								</div>
								<div class="timeIdentity">
									{{item.create_time}}
									<span class="identity">
										{{item.user && item.user.shop_status == 2 ? '画师' : item.gz_status == 1 ? '粉丝' : '游客'}}
									</span>
								</div>
							</div>
						</div>
						<!-- <div class="reportBox" v-if="userId != item.user_id"
							@click="curReport = item;dialogReportVisible = true">
							<img class="reportIcon" src="../../assets/Home/report.png" />
							<span>举报</span>
						</div> -->
					</div>
					<div class="commentContentBox">
						<div class="contentText" v-html="item.content.replace(/\n/g, '<br/>')">
						</div>
						<div class="imgList" v-if="item.banner">
							<el-image class="imgItem" :src="row" fit="cover" :preview-src-list="item.banner"
								v-for="(row,rowIndex) in item.banner" :key="rowIndex">
							</el-image>
						</div>
					</div>
					<div class="commentMenuBox">
						<div class="commentMenuLeft">
							<div class="commentMenuItem">
								<img class="icon" src="../../assets/Home/commentTwo.png" />
								{{item.hf_count}}
							</div>
							<div class="commentMenuItem" style="cursor: pointer;" @click="changeLike(item)">
								<img class="icon" src="../../assets/Home/likeRed.png" v-if="item.zan_status == 1" />
								<img class="icon" src="../../assets/Home/like.png" v-else />
								{{item.dz_num}}
							</div>
						</div>
						<!-- <div class="publish" @click="replyCommunityAdd(item)">发表评论</div> -->
					</div>
					<div class="commentCommentBox" v-if="item.hf_list && item.hf_list.length">
						<div class="commentComment"
							v-for="(row,rowIndex) in item.hf_list.slice(0, item.show ? item.hf_list.length : 3)"
							:key="rowIndex">
							<div class="commentCommentUserInfoBox">
								<div class="commentCommentUserInfo">
									<img class="commentCommentUserInfoavatar" :src="row.user.avatar"
										v-if="row.user && row.user.avatar" />
									<img class="commentCommentUserInfoavatar" src="../../assets/Personal/iconF.png"
										v-else />
									<div class="commentCommentUserInfoNameTime">
										<div class="commentCommentUserInfoName">
											{{row.user && row.user.user_nickname ? row.user.user_nickname : ''}}
										</div>
										<div class="commentCommentUserInfoTimeReply">
											{{row.create_time}}
											<!-- <div class="reply" @click="replyCommunityAdd(row)">
												回复
											</div> -->
										</div>
									</div>
								</div>
							</div>
							<div class="commentCommentContentBox" v-html="row.content.replace(/\n/g, '<br/>')">
							</div>
							<div class="lastCommentList" v-if="row.hf_list && row.hf_list.length">
								<div class="lastComment"
									v-for="(hf, hfIndex) in row.hf_list.slice(0, row.show ? row.hf_list.length : 3)"
									:key="hfIndex">
									<div class="nameLastCommentContent">
										{{hf.user && hf.user.user_nickname ? hf.user.user_nickname : ''}}
										<div class="lastCommentContent">: {{hf.content}}</div>
									</div>
									<div class="lastCommentContentTime">
										{{hf.create_time}}
									</div>
								</div>
								<div class="moreBox" v-if="row.hf_list.length > 3" @click="row.show = !row.show">
									<span v-if="!row.show">共{{ row.hf_list.length }}条回复</span>
									<span v-else>收起</span>
									<img v-if="!row.show" class="downArrow" src="../../assets/Home/downArrow.png" />
									<img v-else class="downArrow" src="../../assets/Home/upArrow.png" />
								</div>
							</div>
						</div>
					</div>
					<div class="lookAllBox" v-if="item.hf_list && item.hf_list.length > 3">
						<div class="lookAll" style="display: flex;align-items: center;" @click="item.show = !item.show">
							{{item.show ? '收起' : '查看'}}全部{{item.hf_list.length}}条评论
							<img class="downTwoArrow" src="../../assets/Home/downTwoArrow.png" />
						</div>
					</div>
				</div>
			</div>
			<PagePagination v-if="total > 0" style="padding: .32rem 0 0;" :currentPage="currentPage" :total="total"
				@current-change="onPageChange" />
		</div>
		<div class="popContainer" v-if="dialogSendViable">
			<div class="dialogContent">
				<div class="title">
					动态发布
					<img class="close" src="../../assets/Feedback/close.png" @click="closeReply" />
				</div>
				<div class="tips">
					温馨提示：<span>3D鞋壳数字平台监督小客服，提示您发布健康的内容哦!</span>
				</div>
				<div class="replyContent">
					<textarea v-model="content" maxlength="200" placeholder="请输入回复内容"></textarea>
					<div class="textNum">
						<span>{{content.length}}</span>/200
					</div>
				</div>
				<div class="imgList">
					<div class="imgItem" v-for="(item,index) in imgList" :key="index">
						<img class="imgItemImg" :src="item" />
						<img class="delete" @click="imgList.splice(index, 1)" src="../../assets/Feedback/delete.png" />
					</div>
					<div class="addImgBox" @click="uploadPhoto" v-if="imgList.length != 6">
						<img class="addImg" src="../../assets/Feedback/addImg.png" />
						上传图片
					</div>
				</div>
				<div class="submit" @click="communityAdd">提交</div>
			</div>
		</div>
		<div class="popContainer" v-if="dialogReplyViable">
			<div class="dialogContent">
				<div class="title">
					动态回复
					<img class="close" src="../../assets/Feedback/close.png" @click="closeReply" />
				</div>
				<div class="tips">
					温馨提示：<span>3D鞋壳数字平台监督小客服，提示您发布健康的内容哦!</span>
				</div>
				<div class="replyContent">
					<textarea v-model="content" maxlength="200" placeholder="请输入回复内容"></textarea>
					<div class="textNum">
						<span>{{content.length}}</span>/200
					</div>
				</div>
				<div class="submit" @click="submitReplyCommunityAdd">提交</div>
			</div>
		</div>
		<PopToast :imgPtahUrl="require('@/assets/Feedback/sucIcon.png')" :desc="successTitle"
			@clickOk="publishPop = false;closeReply()" v-if="publishPop" />
		<PopToast :imgPtahUrl="require('@/assets/Register/fail.png')" :desc="failTitle" :subTitle="failDesc"
			@clickOk="publishFailPop = false;closeReply()" v-if="publishFailPop" />

		<el-dialog class="reportDialog" :visible.sync="dialogReportVisible" append-to-body @close="closeReply">
			<div slot="title">
				<div class="dislogTitle">
					举报
				</div>
			</div>
			<div class="dislogConent">
				<el-form ref="ruleForm" hide-required-asterisk :model="ruleForm" :rules="rules">
					<el-form-item label="温馨提示：" prop="tip">
						<div class="tips">
							很遗憾，给您带来了不好的体验。您可将自己的举报提交3D鞋壳数字平台审核官！
						</div>
					</el-form-item>
					<el-form-item label="举报对象：" prop="user">
						<div class="avatarName">
							<img class="avatar" :src="curReport.user.avatar"
								v-if="curReport.user && curReport.user.avatar" />
							<img class="avatar" src="../../assets/Personal/iconF.png" v-else />
							<div class="name">
								{{curReport.user && curReport.user.user_nickname ? curReport.user.user_nickname : ''}}
							</div>
						</div>
					</el-form-item>
					<el-form-item label="举报原因：" prop="title">
						<el-select v-model="ruleForm.title" class="inputBox" placeholder="请选择举报原因" clearable>
							<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.name" />
						</el-select>
					</el-form-item>
					<el-form-item label="举报描述：" prop="content">
						<div class="reportContent">
							<el-input v-model="ruleForm.content" type="textarea" maxlength="200"
								placeholder="请输入举报描述" />
							<div class="textNum">
								<span>{{ruleForm.content ? ruleForm.content.length : 0}}</span>/200
							</div>
						</div>
					</el-form-item>
					<el-form-item label="证据截图：" prop="img">
						<div class="imgList">
							<div class="imgItem" v-for="(item,index) in imgList" :key="index">
								<img class="imgItemImg" :src="item" />
								<img class="delete" src="../../assets/Feedback/delete.png" />
							</div>
							<div class="addImgBox" @click="uploadPhoto" v-if="imgList.length != 6">
								<img class="addImg" src="../../assets/Feedback/addImg.png" />
								证据截图
							</div>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer">
				<div class="menuBox">
					<el-button class="submit" type="primary" size="medium"
						@click="submitForm('ruleForm')">提交</el-button>
				</div>
			</div>
		</el-dialog>
		<el-upload ref="upload" style="line-height: 0;height: 0;" name="image"
			action="https://ht.daiyuart.com/api.php/set/Other/upload_img" :show-file-list="false" :limit="6" multiple
			:on-success="handlePhotoSuccess">
		</el-upload>
	</div>
</template>

<script>
	import PagePagination from '../../components/PagePagination.vue'
	import PopToast from '../../components/PopToast.vue'
	export default {
		name: 'SuperTalkCommunity',
		components: {
			PagePagination,
			PopToast
		},
		data() {
			return {
				community: {},
				dialogSendViable: false,
				dialogReplyViable: false,
				publishPop: false,
				publishFailPop: false,
				data: [],
				successTitle: '',
				failTitle: '',
				failDesc: '',
				currentPage: 1, // 当前页码
				total: 0, // 总条数
				curNaviIndex: 0,
				naviData: [],
				curReport: {}, //当前举报
				communituId: '', //评论的id
				content: '', //发布动态回复内容
				imgList: [], //发布动态图片
				userId: localStorage.getItem('userId'),
				dialogReportVisible: false,
				options: [{
					id: 1,
					name: '有血腥暴力或淫秽色情等违规内容',
				}, {
					id: 2,
					name: '发表不文明言论',
				}, {
					id: 3,
					name: '其他',
				}],
				ruleForm: {
					title: '',
					content: '',
				},
				rules: {
					title: [{
						required: true,
						message: '请选择举报原因',
						trigger: 'blur'
					}],
				},
			}
		},
		mounted() {
			this.getCommunityDetails()
			this.getDtCommunityDetails()
		},
		methods: {
			uploadPhoto() {
				this.$refs.upload.$el.querySelector('input').click();
			},
			handlePhotoSuccess(response, file) {
				console.log(file)
				this.imgList.push(response.data)
			},
			getDtCommunityDetails() {
				this.$api.post('/Release/dt_community_list', {
					id: this.$route.query.dtId,
				}).then(res => {
					if (res.code == 1) {
						this.community = res.data
						this.naviData = this.community.fenqu ? this.community.fenqu : []
						this.total = res.data.all_count
						this.data = []
						res.data.forEach(item => {
							this.$set(item, 'show', false);
							item.hf_list.forEach(row => {
								this.$set(row, 'show', false);
							})
							this.data.push(item)
						})
					}
				}).catch(err => {
					console.log(err);
				})
			},
			//平台超话排名
			getCommunityDetails() {
				this.$api.post('/Release/community_details', {
					id: this.community.id ? this.community.id : this.$route.query.id,
					qu_id: this.naviData.length ? this.naviData[this.curNaviIndex].id : this.$route.query.quId,
					p: this.currentPage,
				}).then(res => {
					if (res.code == 1) {
						this.community = res.data
						// this.naviData = this.community.fenqu ? this.community.fenqu : []
						// this.total = res.data.all_count
						// this.data = []
						// res.data.all_list.forEach(item => {
						// 	this.$set(item, 'show', false);
						// 	item.hf_list.forEach(row => {
						// 		this.$set(row, 'show', false);
						// 	})
						// 	this.data.push(item)
						// })
					}
				}).catch(err => {
					console.log(err);
				})
			},
			//关注、取消关注
			communityDianzan() {
				this.$api.post('/Release/follow', {
					id: this.community.id,
				}).then(res => {
					if (res.code == 1) {
						this.$message.success(res.msg)
						this.getCommunityDetails()
					}
				}).catch(err => {
					console.log(err);
				})
			},
			changeLike(item) {
				this.$api.post('/Release/dianzan', {
					id: item.id,
				}).then(res => {
					if (res.code == 1) {
						this.$message.success(res.msg)
						this.getCommunityDetails()
					} else {
						this.$message.error(res.msg)
					}
				}).catch(err => {
					this.$message.error('点赞失败，请稍后再试！')
					console.log(err);
				})
			},
			//发布超话
			communityAdd() {
				if (!this.content) return this.$message.warning('请输入回复内容')
				this.$api.post('/Release/community_add', {
					sid: this.community.id,
					content: this.content,
					banner: this.imgList.join(','),
					qu_id: this.naviData.length ? this.naviData[this.curNaviIndex].id : this.$route.query.quId,
				}).then(res => {
					this.closeReply()
					if (res.code == 1) {
						this.successTitle = '发布成功'
						this.publishPop = true
						this.getCommunityDetails()
					} else {
						this.failTitle = '发布失败'
						this.failDesc = '平台 AI 智能图文检测未通过请您修改后再提交'
						this.publishFailPop = true
					}
				}).catch(err => {
					this.$message.error('发布动态失败，请稍后再试！')
					console.log(err);
				})
			},
			//回复超话
			replyCommunityAdd(item) {
				this.communituId = item.id
				this.dialogReplyViable = true
			},
			submitReplyCommunityAdd() {
				if (!this.content) return this.$message.warning('请输入回复内容')
				this.$api.post('/Release/hf_community_add', {
					sid: this.community.id,
					content: this.content,
					banner: '',
					xid: this.communituId,
				}).then(res => {
					this.dialogReplyViable = false
					if (res.code == 1) {
						this.successTitle = '发布成功'
						this.publishPop = true
						this.getCommunityDetails()
					} else {
						this.failTitle = '发布失败'
						this.failDesc = '平台 AI 智能图文检测未通过请您修改后再提交'
						this.publishFailPop = true
					}
				}).catch(err => {
					console.log(err);
				})
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$api.post('/Release/community_jubao', {
							title: this.ruleForm.title,
							content: this.ruleForm.content,
							banner: this.imgList.join(','),
							cid: this.curReport.id,
						}).then(res => {
							this.dialogReportVisible = false
							if (res.code == 1) {
								this.successTitle = '举报成功'
								this.publishPop = true
								this.ruleForm.title = ''
								this.ruleForm.content = ''
								this.getCommunityDetails()
							} else {
								this.failTitle = '举报失败'
								this.failDesc = '您已举报过该评论'
								this.publishFailPop = true
							}
						}).catch(err => {
							console.log(err);
						})
					} else {
						return false
					}
				})
			},
			changeFenQu(index) {
				this.curNaviIndex = index
				this.getCommunityDetails()
			},
			// 页码变化处理
			onPageChange(newPage) {
				this.currentPage = newPage
				this.getCommunityDetails()
			},
			replyComment() {
				this.dialogReplyViable = true
				document.body.style.overflow = 'hidden';
			},
			closeReply() {
				this.content = ''
				this.imgList = []
				this.communituId = ''
				this.ruleForm.title = ''
				this.ruleForm.content = ''
				this.dialogSendViable = false
				this.dialogReplyViable = false
				document.body.style.overflow = '';
			}
		},
	}
</script>

<style lang="scss" scoped>
	.latform-hypertalk-container {
		margin: .24rem .24rem;
		display: flex;
		flex-direction: column;
		background: #FFFFFF;
		border-radius: .08rem;
		padding: .24rem .4rem;
	}

	.content-container {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	/* 面包屑导航样式 */
	.breadcrumb {
		display: flex;
		align-items: center;
		font-weight: 400;
		font-size: .14rem;
		color: #000000;
	}

	.breadcrumb-item {
		color: #000000;
		text-decoration: none;
		transition: color 0.3s ease;
	}

	.breadcrumb-item:hover {
		color: #000000;
	}

	.breadcrumb-item.current {
		color: #000000;
		font-weight: 500;
	}

	.breadcrumb-separator {
		margin: 0 0.02rem;
		color: #000000;
	}

	.rankItem {
		width: 100%;
		height: 2.24rem;
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: #FFFFFF;
		border-radius: .12rem;
		box-sizing: border-box;

		.work {
			display: flex;

			.workImg {
				width: 1.6rem;
				height: 1.6rem;
				border-radius: .08rem;
				object-fit: cover;
			}

			.workInfo {
				width: 5.1rem;
				margin-left: .24rem;
				display: flex;
				flex-direction: column;

				.workTitle {
					font-weight: 600;
					font-size: .24rem;
					color: #000000;
				}

				.workDesc {
					margin-top: .1rem;
					font-weight: 400;
					font-size: .14rem;
					line-height: .2rem;
					color: #333333;
				}

				.peopleComment {
					margin-top: .16rem;
					display: flex;
					align-items: center;

					.people,
					.comment {
						margin-right: .2rem;
						display: flex;
						align-items: center;
						font-weight: 400;
						font-size: .14rem;
						color: #7C400E;
						line-height: .2rem;
					}

					.peopleIcon,
					.commentIcon {
						width: .14rem;
						height: .14rem;
						margin-right: .08rem;
					}
				}

				.tips {
					margin-top: .1rem;
					display: flex;
					align-items: center;

					.tip {
						font-size: .14rem;
						color: #786F22;
						line-height: .2rem;
						margin-right: .166rem;
					}
				}
			}
		}

		.menuBox {
			display: flex;
			flex-direction: column;

			.menuItem {
				margin: .08rem 0;
				display: flex;
				align-items: center;
				justify-content: center;
				width: 1.4rem;
				height: .4rem;
				border-radius: .06rem;
				box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
				font-weight: 400;
				font-size: .14rem;
				line-height: .36rem;
				cursor: pointer;
			}


			.publish {
				background: #E29358;
				box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
				color: #312C28;

				.publishIcon {
					margin-right: .06rem;
					width: .13rem;
					height: .13rem;
				}
			}

			.follow {
				color: #706614;
				border: .01rem solid #706614
			}
		}

		.goTo {
			position: absolute;
			top: calc(50% - .2rem);
			right: 0;
			width: 1.52rem;
			height: .4rem;
			box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
			border-radius: 6px;
			border: .01rem solid #E29358;
			font-weight: 400;
			font-size: .14rem;
			color: #E29358;
			text-align: center;
			line-height: .4rem;
			cursor: pointer;
		}
	}

	.naviBox {
		display: flex;
		align-items: center;

		.naviItem {
			margin-right: .24rem;
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 0 .24rem;
			height: .4rem;
			border-radius: .04rem;
			background: #E29358;
			font-size: .16rem;
			text-align: center;
			line-height: .36rem;
			cursor: pointer;
		}

		.active {
			font-weight: 500;
			color: #252525;
			background: #E29358;
		}

		.normal {
			font-weight: 400;
			color: #000000;
			background: rgba(226, 147, 88, .3);
		}
	}

	.commentBoxList {
		width: 100%;
		display: flex;
		flex-direction: column;

		.comment {
			margin-top: .24rem;
			display: flex;
			flex-direction: column;
			width: 100%;
			background: #FFFFFF;
			border-radius: .12rem;

			.userInfoBox {
				display: flex;
				align-items: center;
				justify-content: space-between;

				.userInfo {
					display: flex;
					align-items: center;

					.avatar {
						width: .68rem;
						height: .68rem;
						border-radius: 50%;
						overflow: hidden;
						object-fit: cover;
					}

					.nameTimeIdentity {
						margin-left: .16rem;
						display: flex;
						flex-direction: column;

						.nameBox {
							display: flex;
							align-items: center;
							font-weight: bold;
							font-size: .18rem;
							color: #312C28;

							.toTop {
								margin-left: .08rem;
								height: .2rem;
								display: flex;
								align-items: center;
								justify-content: center;
								padding: 0rem .08rem;
								border: .01rem solid #F56C6C;
								border-radius: .1rem;
								font-weight: 400;
								font-size: .12rem;
								color: #F56C6C;

								.toTopIcon {
									margin-right: .02rem;
									width: .1rem;
									height: .1rem;
								}
							}
						}

						.timeIdentity {
							margin-top: .08rem;
							font-weight: 400;
							font-size: .14rem;
							color: #999999;

							.identity {
								margin-left: .08rem;
							}
						}
					}
				}

				.reportBox {
					display: flex;
					align-items: center;
					font-weight: 400;
					font-size: .12rem;
					color: #999999;
					cursor: pointer;

					.reportIcon {
						width: .14rem;
						height: .14rem;
						margin-right: .04rem;
					}
				}
			}

			.commentContentBox {
				margin: .16rem .48rem 0 .84rem;
				display: flex;
				flex-direction: column;

				.contentText {
					font-weight: 400;
					font-size: .16rem;
					color: #312C28;
					line-height: .24rem;
				}

				.imgList {
					margin-top: .12rem;
					display: flex;
					flex-wrap: wrap;

					.imgItem {
						margin-top: .12rem;
						margin-right: .12rem;
						width: 1.54rem;
						height: 2.06rem;
						object-fit: cover;
						border-radius: .08rem;
						cursor: pointer;
					}
				}
			}

			.commentMenuBox {
				margin: .24rem 0 0 .84rem;
				display: flex;
				align-items: center;
				justify-content: space-between;

				.commentMenuLeft {
					display: flex;
					align-items: center;

					.commentMenuItem {
						width: .72rem;
						display: flex;
						align-items: center;
						font-weight: 400;
						font-size: .14rem;
						color: #666666;

						.icon {
							margin-right: .08rem;
							width: .16rem;
							height: .16rem;
						}
					}
				}

				.publish {
					display: flex;
					align-items: center;
					justify-content: center;
					width: .88rem;
					height: .4rem;
					background: #E29358;
					box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
					border-radius: .06rem;
					font-weight: 400;
					font-size: .14rem;
					color: #252525;
					cursor: pointer;
				}
			}

			.commentCommentBox {
				margin-top: .16rem;
				display: flex;
				flex-direction: column;
				// padding: 0 0 .24rem .68rem;
				border-top: .01rem solid #CCCCCC;
				// border-bottom: .01rem solid #CCCCCC;

				.commentComment {
					margin-top: .24rem;
					display: flex;
					flex-direction: column;

					.commentCommentUserInfoBox {
						display: flex;
						align-items: center;

						.commentCommentUserInfo {
							width: 100%;
							display: flex;
							align-items: center;
							padding-left: .68rem;

							.commentCommentUserInfoavatar {
								width: .36rem;
								height: .36rem;
								border-radius: 50%;
								object-fit: cover;
							}

							.commentCommentUserInfoNameTime {
								width: 100%;
								display: flex;
								flex-direction: column;
								margin-left: .08rem;

								.commentCommentUserInfoName {
									font-weight: 500;
									font-size: .12rem;
									color: #312C28;
									line-height: .18rem;
								}

								.commentCommentUserInfoTimeReply {
									width: 100%;
									margin-top: .02rem;
									display: flex;
									align-items: center;
									justify-content: space-between;
									font-weight: 400;
									font-size: .12rem;
									color: #999999;
									line-height: .18rem;

									.reply {
										color: #E29358;
										cursor: pointer;
									}
								}
							}
						}
					}

					.commentCommentContentBox {
						margin: .12rem 0 0 1.12rem;
						font-weight: 400;
						font-size: .14rem;
						color: #312C28;
					}

					.lastCommentList {
						margin: .2rem 0 0 1.12rem;
						padding-left: .16rem;
						display: flex;
						flex-direction: column;
						border-left: .01rem solid #CCCCCC;

						.lastComment:first-child {
							margin-top: 0;
						}

						.lastComment {
							margin-top: .12rem;
							display: flex;
							flex-direction: column;

							.nameLastCommentContent {
								display: flex;
								align-items: center;
								font-weight: 400;
								font-size: .14rem;
								color: #E29358;

								.lastCommentContent {
									color: #312C28;
								}
							}

							.lastCommentContentTime {
								font-weight: 400;
								font-size: .12rem;
								color: #999999;
							}
						}

						.moreBox {
							margin-top: .12rem;
							display: flex;
							align-items: center;
							font-weight: 400;
							font-size: .12rem;
							color: #E29358;
							cursor: pointer;

							.downArrow {
								width: .06rem;
								height: .04rem;
								margin-left: .02rem;
							}
						}
					}
				}
			}
		}

		.lookAllBox {
			margin: .24rem 0 0;
			display: flex;
			align-items: center;
			justify-content: center;
			padding-top: .24rem;
			border-top: .01rem solid #CCCCCC;
			font-weight: 400;
			font-size: .14rem;
			color: #666666;

			.lookAll {
				display: flex;
				align-items: center;
				cursor: pointer;

				.downTwoArrow {
					width: .12rem;
					height: .06rem;
					margin-left: .06rem;
				}
			}
		}
	}

	.popContainer {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		background: rgba(0, 0, 0, 0.5);
		z-index: 102;

		.dialogContent {
			width: 7.4rem;
			background: #FFFFFF;
			border-radius: .12rem;
			display: flex;
			flex-direction: column;
			padding: .24rem .24rem;

			.title {
				display: flex;
				align-items: center;
				justify-content: space-between;
				font-weight: 500;
				font-size: .18rem;
				color: #252525;
				line-height: .26rem;

				.close {
					width: .14rem;
					height: .14rem;
					cursor: pointer;
				}
			}

			.tips {
				margin-top: .24rem;
				display: flex;
				align-items: center;
				font-weight: 400;
				font-size: .14rem;
				color: #252525;
				line-height: .2rem;

				span {
					font-weight: 500;
					color: #312C28;
				}
			}

			.replyContent {
				margin-top: .24rem;
				width: 6.92rem;
				height: 1.6rem;
				background: #FFFFFF;
				border-radius: .04rem;
				border: .01rem solid #EFD8B8;
				position: relative;

				.textNum {
					position: absolute;
					right: .12rem;
					bottom: .12rem;
					display: flex;
					align-items: center;
					font-weight: 400;
					font-size: .14rem;
					color: #999999;
					line-height: .2rem;

					span {
						color: #252525;
					}
				}

				textarea {
					width: 100%;
					height: 100%;
					border: none;
					padding: .12rem .12rem;
					font-weight: 400;
					font-size: .14rem;
				}
			}

			.imgList {
				margin-top: .24rem;
				display: flex;
				flex-wrap: wrap;

				.imgItem {
					margin-right: .16rem;
					display: flex;
					width: .86rem;
					height: .86rem;
					border-radius: .04rem;
					overflow: hidden;
					position: relative;

					.delete {
						position: absolute;
						top: .05rem;
						right: .05rem;
						width: .14rem;
						height: .14rem;
						cursor: pointer;
					}

					.imgItemImg {
						width: .86rem;
						height: .86rem;
						object-fit: cover;
					}
				}

				.addImgBox {
					width: .86rem;
					height: .86rem;
					border-radius: .04rem;
					background: #FFFFFF;
					border: 1px solid #EFD8B8;
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;
					font-weight: 400;
					font-size: .12rem;
					color: #999999;
					cursor: pointer;

					.addImg {
						margin-bottom: .08rem;
						width: .27rem;
						height: .23rem;
					}
				}
			}

			.submit {
				margin: .32rem auto 0;
				width: 1.3rem;
				height: .36rem;
				background: #E29358;
				border-radius: .04rem;
				font-weight: 400;
				font-size: .14rem;
				color: #252525;
				text-align: center;
				line-height: .36rem;
				cursor: pointer;
			}
		}
	}

	.reportDialog {

		::v-deep .el-dialog {
			width: 7.40rem;
			border-radius: .12rem;

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}

			&__body {
				padding: 0 .24rem;

				.tips {
					display: flex;
					align-items: center;
					font-weight: 500;
					font-size: .14rem;
					color: #312C28;
					line-height: .2rem;
				}

				.avatarName {
					display: flex;
					align-items: center;

					.avatar {
						margin-right: .08rem;
						width: .4rem;
						height: .4rem;
						border-radius: 50%;
						overflow: hidden;
						object-fit: cover;
					}

					.name {
						font-weight: 500;
						font-size: .14rem;
						color: #312C28;
					}
				}

				.reportContent {
					position: relative;

					.textNum {
						position: absolute;
						right: .12rem;
						bottom: .12rem;
						display: flex;
						align-items: center;
						font-weight: 400;
						font-size: .14rem;
						color: #999999;
						line-height: .2rem;

						span {
							color: #252525;
						}
					}
				}

				.imgList {
					display: flex;
					flex-wrap: wrap;

					.imgItem {
						margin-right: .16rem;
						display: flex;
						width: .86rem;
						height: .86rem;
						border-radius: .04rem;
						overflow: hidden;
						position: relative;

						.delete {
							position: absolute;
							top: .05rem;
							right: .05rem;
							width: .14rem;
							height: .14rem;
							cursor: pointer;
						}

						.imgItemImg {
							width: .86rem;
							height: .86rem;
							object-fit: cover;
						}
					}

					.addImgBox {
						width: .86rem;
						height: .86rem;
						border-radius: .04rem;
						background: #FFFFFF;
						border: 1px solid #EFD8B8;
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;
						font-weight: 400;
						font-size: .12rem;
						color: #999999;
						cursor: pointer;
						line-height: .18rem;

						.addImg {
							margin-bottom: .08rem;
							width: .27rem;
							height: .23rem;
						}
					}
				}

				.el-form {

					&-item:nth-child(4),
					&-item:nth-child(5) {
						align-items: flex-start;

						.el-form-item__label {
							margin-top: .16rem;
						}
					}

					&-item {
						display: flex;
						align-items: center;
						margin-bottom: .24rem;

						&__label {
							font-size: .14rem;
							color: #252525;
							line-height: .2rem;
						}

						&__content {

							.el-textarea {
								&__inner {
									width: 6rem;
									height: 1.6rem;
									background: #FFFFFF;
									border-radius: .04rem;
									border: .01rem solid #EFD8B8;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
								}
							}

							.el-input {

								&__inner {
									width: 4.1rem;
									height: .52rem;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
									line-height: .52rem;
									border: .01rem solid #EFD8B8;
								}

								&__icon {
									font-size: .14rem;
								}
							}
						}
					}
				}
			}

			&__footer {
				padding: .08rem .24rem .24rem;

				.menuBox {
					display: flex;
					align-items: center;
					justify-content: center;

					.submit {
						margin: .32rem auto 0;
						width: 1.3rem;
						height: .36rem;
						background: #E29358;
						border-radius: .04rem;
						padding: 0 0;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						text-align: center;
						line-height: .36rem;
						border: none;
						cursor: pointer;
					}
				}
			}
		}
	}

	li {
		font-size: .14rem !important;
		margin-bottom: 0;
	}
</style>